var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H3.83333V3.83333H0V0ZM4.79167 3.83333V0H8.625V3.83333H4.79167ZM9.58333 3.83333V0H13.4167V3.83333H9.58333ZM14.375 3.83333V0H18.2083V3.83333H14.375ZM19.1667 3.83333V0H23V1H24V2V24H23H1V23H0V19.1667H3.83333V23H4.79167V19.1667H8.625V23H9.58333V19.1667H13.4167V23H14.375V19.1667H18.2083V23H19.1667V19.1667H23V18.2083H19.1667V14.375H23V13.4167H19.1667V9.58333H23V8.625H19.1667V4.79167H23V3.83333H19.1667ZM3.83333 18.2083H0V14.375H3.83333V18.2083ZM3.83333 13.4167H0V9.58333H3.83333V13.4167ZM3.83333 8.625H0V4.79167H3.83333V8.625ZM18.2083 18.2083V14.375H14.375V18.2083H18.2083ZM13.4167 18.2083V14.375H9.58333V18.2083H13.4167ZM8.625 18.2083V14.375H4.79167V18.2083H8.625ZM4.79167 13.4167V9.58333H8.625V13.4167H4.79167ZM4.79167 8.625H8.625V4.79167H4.79167V8.625ZM9.58333 13.4167V9.58333H13.4167V13.4167H9.58333ZM9.58333 8.625H13.4167V4.79167H9.58333V8.625ZM14.375 13.4167V9.58333H18.2083V13.4167H14.375ZM14.375 8.625H18.2083V4.79167H14.375V8.625Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/Layers.950b1b287fcb4e97a6d22755783ea718.svg";
export { ForwardRef as ReactComponent };